import { motion } from "motion/react";

interface PageHeroProps {
    image: string;
    label: string;
    title: string;
}

export function PageHero({ image, label, title }: PageHeroProps) {
    return (
        <header className="relative h-[60vh] flex items-center justify-center overflow-hidden">
            <motion.div
                initial={{ scale: 1.05 }}
                animate={{ scale: 1 }}
                transition={{ duration: 1.5 }}
                className="absolute inset-0 z-0"
            >
                <img
                    src={image}
                    alt={title}
                    className="w-full h-full object-cover brightness-[0.6]"
                    referrerPolicy="no-referrer"
                />
            </motion.div>
            <div className="relative z-10 text-center text-white px-6">
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3 }}
                    className="uppercase tracking-[0.3em] text-sm mb-4 font-light"
                >
                    {label}
                </motion.p>
                <motion.h1
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5 }}
                    className="font-serif text-5xl md:text-7xl font-light italic"
                >
                    {title}
                </motion.h1>
            </div>
        </header>
    );
}
